var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"color":_vm.toolbarColor,"dark":_vm.darkToolbar,"height":_vm.height,"dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('v-card',{staticClass:"mx-auto",attrs:{"color":_vm.color,"tile":true}},[_c('v-card-text',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d35a5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoCard.vue
// module id = null
// module chunks = 